import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  apiAddProvider,
  apiDeleteProvider,
  apiGetProvider,
  apiGetProviders,
  apiUpdateProvider,
} from "@lib/api/provider";
import { toast } from "react-toastify";
import { UseQueriesProps } from "@lib/types/General";

export const useProviderQueries = (props: UseQueriesProps) => {
  const { queryKey, params, id, messages, enabled = true } = props;
  const queryKeys = queryKey || [
    "provider",
    params ? JSON.stringify(params) : id,
  ];
  const queryClient = useQueryClient();

  const providerQuery = useQuery({
    queryFn: () => apiGetProvider(id),
    queryKey: ["provider", id],
    enabled: !!id && !!enabled,
  });

  const providersQuery = useQuery({
    queryFn: () => apiGetProviders(params),
    queryKey: queryKeys,
    enabled: !!params && !!enabled,
  });

  const addProviderMutation = useMutation({
    mutationFn: apiAddProvider,
    mutationKey: ["provider"],
    onSuccess() {
      toast.success(
        (messages["common.createdMessage"] as string).replace(
          "{name}",
          messages["common.provider"] as string,
        ),
      );
      queryClient.invalidateQueries({
        queryKey: queryKeys,
      });
    },
  });

  const deleteProviderMutation = useMutation({
    mutationFn: apiDeleteProvider,
    mutationKey: ["provider"],
    onSuccess() {
      toast.success(
        (messages["common.deletedMessage"] as string).replace(
          "{name}",
          messages["common.provider"] as string,
        ),
      );
      queryClient.invalidateQueries({
        queryKey: queryKeys,
      });
    },
  });

  const updateProviderMutation = useMutation({
    mutationFn: apiUpdateProvider,
    mutationKey: ["provider"],
    onSuccess() {
      toast.success(
        (messages["common.updatedMessage"] as string).replace(
          "{name}",
          messages["common.provider"] as string,
        ),
      );
      queryClient.invalidateQueries({
        queryKey: queryKeys,
      });
    },
  });

  return {
    providerQuery,
    providersQuery,
    addProviderMutation,
    deleteProviderMutation,
    updateProviderMutation,
  };
};
